import None from './None.json'
import Custom from './Custom.json'

export class RoleTemplate {
    public name: string = 'Custom'
    public value: string = 'CUSTOM'
    public description?: string = ''
    public requiresReporting?: boolean = false
    public permissions?: string[] = []
    public isAdmin?: boolean
    public isCustomRole?: boolean
}

export const REPORTING_USER_ROLE_ID: string = 'REPORTING_USER'

export type RoleTemplateKeyed = { [key: string]: RoleTemplate }

export const Roles: RoleTemplateKeyed = [None, Custom].reduce((accum, next) => {
    accum[next.value] = next
    return accum
}, {} as RoleTemplateKeyed)
